<template>
    <div class="reminder">
        <!-- <glance :header="header" :layout="layout" :glance-data="selectedReminder"></glance> -->
        <tab-bar :tabs="tabs"></tab-bar>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
import { mapState } from 'vuex';
import Glance from '../Glance';
import TabBar from '../TabBar';
import store from '../../store.js';

export default {
	data () {
	    return {
	      header: {
	        heading: ['label', 'description', 'days_before', 'days_after', 'status'],
	        label: 'Reminder'
	      },
	      ReminderGlance: 'reminder-glance',
	      tabs: {
	        // 'details': 'Details',
	        // 'policies': 'Policies',
	        // 'quotations': 'Quotations',
	        // 'payments': 'Payments',
	        // 'endorsements': 'Endorsements',
	        // 'claims': 'Claims',
	        // 'audit-trail': 'Audit Trail',
	        // 'documents': 'Documents'
	      }
		};
	},

	computed: mapState({
    reminders: state => state.reminders,
    reminder: state => state.reminder,
    layout: state => state.viewLayouts['reminder-glance'],
  	}),
  	components: {
  		Glance,
    	TabBar
  	},
  	beforeRouteEnter (to, from, next) {
  		store.dispatch('fetchSelectedReminder', { id: to.params.id });
    	store.dispatch('fetchLayoutForView', { name: 'reminder-detail'});
    	// store.dispatch('fetchLayoutForView', { name: 'customer-glance'});
    	next();
  	}
};
</script>

<style lang="scss"></style>


// WEBPACK FOOTER //
// src/components/reminder/Reminder.vue